import React, { useState } from 'react';
// @ts-ignore
import styles from './InsuranceCompanyOperations.module.scss';
import {
	useInsuranceOperationDeleteMutation,
	useInsuranceOperationsQuery,
} from '../../../../graphql/graphql';
import Loading from '../../../../Components/Loading';
import { Theme } from '../../../../Enums/Theme.enum';
import LinkButton from '../../../../Components/Button/LinkButton';
import InsuranceCompanyAddOperationModal from '../InsuranceCompanyAddOperation/InsuranceCompanyAddOperationModal';
import RemoveButton from '../../../../Components/Button/RemoveButton';
import useNotification from '../../../../Hooks/useNotification.hook';
import useTranslation from '../../../../Hooks/useTranslation';

interface Props {
	insuranceId: string;
	name: string;
	rootWorkplaceId: string;
}

const InsuranceCompanyOperations: React.FC<Props> = ({
	insuranceId,
	rootWorkplaceId,
	name,
}) => {
	const { showNotificationSuccess } = useNotification();
	const { t } = useTranslation();
	const { data, isLoading, refetch } = useInsuranceOperationsQuery({
		where: { insuranceId, workplaceId: rootWorkplaceId },
	});
	const [deleteOperation] = useInsuranceOperationDeleteMutation();
	const [
		isInsuranceCompanyAddOperationOpen,
		setIsInsuranceCompanyAddOperationOpen,
	] = useState(false);

	const handleAfterAdd = () => {
		setIsInsuranceCompanyAddOperationOpen(false);
		refetch();
	};

	const handleRemove = async (id: string) => {
		const result = await deleteOperation({ id });
		if ('data' in result) {
			refetch();
		}
	};

	if (isLoading) {
		return <Loading />;
	}

	return (
		<div className={styles.wrapper}>
			<div className={styles.header}>
				<div className={styles.title}>{name}</div>
			</div>
			<div className={styles.content}>
				<table className='table'>
					<thead>
						<tr>
							<th>{t('component.insuranceCompanyOperations.thead.code')}</th>
							<th>{t('component.insuranceCompanyOperations.thead.name')}</th>
							<th>{t('component.insuranceCompanyOperations.thead.points')}</th>
							<th>
								{t('component.insuranceCompanyOperations.thead.priceForPoint')}
							</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						{data?.insuranceOperations?.data?.map(item => {
							if (item) {
								return (
									<tr>
										<td>{item.code}</td>
										<td>{item.title}</td>
										<td>{item.points}</td>
										<td>{item.pricePerPoint}</td>
										<td>
											<RemoveButton
												onClick={() => handleRemove(item.id)}
												firstUpper
											/>
										</td>
									</tr>
								);
							}
						})}
					</tbody>
				</table>
				<LinkButton
					theme={Theme.BLUE}
					title='base.shared.add'
					onClick={() => setIsInsuranceCompanyAddOperationOpen(true)}
					firstUpper
				/>
			</div>
			{isInsuranceCompanyAddOperationOpen && (
				<InsuranceCompanyAddOperationModal
					isOpen
					insuranceId={insuranceId}
					rootWorkplaceId={rootWorkplaceId}
					onClose={() => setIsInsuranceCompanyAddOperationOpen(false)}
					onCreate={handleAfterAdd}
				/>
			)}
		</div>
	);
};

export default InsuranceCompanyOperations;
